export const CLIENT_INSTAGRAM_TEXT_CLASS =
    " text-[10px] md:text-base font-medium font-Montserrat not-italic	text-Heading_Black leading-3 sm:leading-5 pl-1 pr-1 p-2.5";
